var React = require('react');

function MenuShapeTriangleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M118.672 104.812L695.378 328.466L251.814 759.583L118.672 104.812Z","stroke":"#FF00FF"}));
}

MenuShapeTriangleInline.defaultProps = {"width":"764","height":"782","viewBox":"0 0 764 782","fill":"none"};

module.exports = MenuShapeTriangleInline;

MenuShapeTriangleInline.default = MenuShapeTriangleInline;
